/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import {useEffect, useState} from "react";

// react-router-dom components
import {Link} from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

// Image
import bgImage from "assets/images/illustrations/illustration-reset.jpg";
import {useDispatch, useSelector} from "react-redux";
import {useLoginMutation, useMeQuery} from "../../../../store/api/auth";
import {useNavigate} from "react-router-dom";
import {notificationActions} from "../../../../store/notification/notification-slice";
import {InputLabel, TextField} from "@mui/material";
import {GoogleAuthProvider, signInWithPopup, getAuth, signInWithEmailAndPassword, OAuthProvider} from 'firebase/auth';


function Illustration() {
    const [rememberMe, setRememberMe] = useState(false);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [isEmailValid, setIsEmailValid] = useState(true);

    const handleSetRememberMe = () => setRememberMe(!rememberMe);

    const {data: user, refetch} = useMeQuery();
    const dispatch = useDispatch();

    const [login] = useLoginMutation()
    let navigate = useNavigate();

    useEffect(() => {
        const emailVal = localStorage.getItem("email");
        if (emailVal) {
            setEmail(emailVal);
        }
    }, []);
    useEffect(() => {
        if (user) {
            navigate('/');
        }

    }, [user, navigate]);

    const provider = new GoogleAuthProvider();


    const googleLoginHandler = async (e) => {
        const auth = getAuth();
        signInWithPopup(auth, provider)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = GoogleAuthProvider.credentialFromResult(result);

                // The signed-in user info.
                const user = result.user;
                const token = user.accessToken;
                localStorage.setItem('token', token);
                // IdP data available using getAdditionalUserInfo(result)
                // ...
                dispatch(notificationActions.showMessage({message: "Logged in successfully", variant: 'success'}));
                refetch();
            }).catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.customData.email;
            // The AuthCredential type that was used.
            const credential = GoogleAuthProvider.credentialFromError(error);
            dispatch(notificationActions.showMessage({message: errorMessage, variant: 'error'}));


            // ...
        });
    }
    const provider_apple = new OAuthProvider('apple.com');

    const appleLoginHandler = async (e) => {
        const auth = getAuth();
        signInWithPopup(auth, provider_apple)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = OAuthProvider.credentialFromResult(result);

                // The signed-in user info.
                const user = result.user;
                const token = user.accessToken;
                localStorage.setItem('token', token);
                // IdP data available using getAdditionalUserInfo(result)
                // ...
                dispatch(notificationActions.showMessage({message: "Logged in successfully", variant: 'success'}));
                refetch();
            }).catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.customData.email;
            // The AuthCredential type that was used.
            const credential = OAuthProvider.credentialFromError(error);
            dispatch(notificationActions.showMessage({message: errorMessage, variant: 'error'}));
            // ...
        });
    }
    const loginHandler = async (e) => {
        e.preventDefault();
        dispatch(notificationActions.showLoading(true));
        const auth = getAuth();

        try {
            await signInWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    // Signed in
                    const user = userCredential.user;
                    // navigate("/home")
                    dispatch(notificationActions.showMessage({message: "Logged in successfully", variant: 'success'}));
                    localStorage.setItem('token', user.accessToken);
                    // navigate("/profile");
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    dispatch(notificationActions.showMessage({message: errorMessage, variant: 'error'}));
                });
            // const payload = await login({email, password}).unwrap();
            //localStorage.setItem('token', payload.access);
            //dispatch(authActions.setCredentials(payload));
            refetch();
        } catch (e) {
            dispatch(notificationActions.showMessage({message: e.data.detail, variant: 'error'}));
        }
        dispatch(notificationActions.showLoading(false));
    }

    const handleEmail = (e) => {
        setEmail(e.target.value);
        setIsEmailValid(checkEmail(e.target.value));
    }

    const checkEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    return (
        <IllustrationLayout
            title="Sign In"
            description="Enter your email and password to sign in"
            illustration={bgImage}
        >
            <MDBox component="form" role="form">
                <MDBox mb={2}>
                    <TextField
                        type="email" label="Email"
                        helperText={!isEmailValid ? "Not valid email" : ""}
                        value={email}
                        error={!isEmailValid}
                        onChange={handleEmail}
                        fullWidth
                    />
                </MDBox>
                <MDBox mb={2}>
                    <TextField type="password" label="Password" onChange={(e) => {
                        setPassword(e.target.value)
                    }} fullWidth/>
                </MDBox>
                <MDBox display="flex" alignItems="center" ml={-1}>
                    <Switch checked={rememberMe} onChange={handleSetRememberMe}/>
                    <MDTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                        onClick={handleSetRememberMe}
                        sx={{cursor: "pointer", userSelect: "none", ml: -1}}
                    >
                        &nbsp;&nbsp;Remember me
                    </MDTypography>
                </MDBox>
                <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" disabled={!isEmailValid || !email || !password} onClick={loginHandler}
                              color="info" size="large" fullWidth>
                        sign in
                    </MDButton>
                </MDBox>
                <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" onClick={googleLoginHandler}
                              color="info" size="large" fullWidth>
                        sign in with google
                    </MDButton>
                </MDBox>
                <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" onClick={appleLoginHandler}
                              color="info" size="large" fullWidth>
                        sign in with apple
                    </MDButton>
                </MDBox>
                <MDBox mt={3} textAlign="center">
                    <MDTypography variant="button" color="text">
                        Don&apos;t have an account?{" "}
                        <MDTypography
                            component={Link}
                            to="/authentication/sign-up"
                            variant="button"
                            color="info"
                            fontWeight="medium"
                            textGradient
                        >
                            Sign up
                        </MDTypography>
                    </MDTypography>
                </MDBox>
                <MDBox mt={3} textAlign="center">
                    <MDTypography variant="button" color="text">
                        Forgot your password?{" "}
                        <MDTypography
                            component={Link}
                            to="/authentication/reset-password"
                            variant="button"
                            color="info"
                            fontWeight="medium"
                            textGradient
                        >
                            Reset
                        </MDTypography>
                    </MDTypography>
                </MDBox>
            </MDBox>
        </IllustrationLayout>
    );
}

export default Illustration;
